import z from "zod";

import type {
  CollapsibleTriggerSize,
  CollapsibleTriggerVariant,
} from "./Collapsible.types";

export const collapsibleDataSchema = z.object({
  defaultOpen: z
    .string()
    .optional()
    .transform((value) => value !== undefined && value !== "false")
    .describe(
      "Initial open state, read once at mount — use the imperative open()/close()/toggle() handle instead to change it after the initial render.",
    ),
  size: z
    .custom<CollapsibleTriggerSize>()
    .optional()
    .describe(
      "Forwarded to the inner <Collapsible> for its own React-tree context — does not reach <rwc-collapsible-trigger>, which is a separate mount point and reads this attribute itself via readCollapsibleTriggerSlotted.",
    ),
  variant: z
    .custom<CollapsibleTriggerVariant>()
    .optional()
    .describe(
      "Forwarded to the inner <Collapsible> for its own React-tree context — does not reach <rwc-collapsible-trigger>, which is a separate mount point and reads this attribute itself via readCollapsibleTriggerSlotted.",
    ),
  onOpenChange: z
    .custom<(open: boolean) => void>()
    .optional()
    .describe(
      "Internal callback bound by readCollapsibleSlotted — not a Twig-authored attribute, passed through the same raw-props pipeline.",
    ),
});

export type CollapsibleDataProps = z.infer<typeof collapsibleDataSchema>;

export const collapsibleTriggerDataSchema = z.object({
  label: z
    .string()
    .optional()
    .describe(
      "Label text for the trigger button, read from the element's textContent if not set.",
    ),
});

export type CollapsibleTriggerDataProps = z.infer<
  typeof collapsibleTriggerDataSchema
>;
